export default __webpack_public_path__ + "static/media/family-2-stock.37d0d5c6.jpg";